import { useRef } from 'react';
import classes from './AddNewPlayList.module.css'
import Button from '../../../buttons/authButton/Button';
import { LanguageContext } from '../../../../context/LanguageContext';

const AddNewPlayList = (props) => {
  // eslint-disable-next-line no-unused-vars
  const {playlists, updateExsistingPlaylists, playlistCount, setLimit, limit, defaultLimit, selectIsChecked, setUpdate, onHide, save, disableSaveButton, cartoonId} = props

  const ref = useRef(null)

  const playListAction = (type) => {
    type === 'save' ? save() : onHide();
  }

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <>
            <div
              className={`${classes.playlists} overflow-auto`}
              id='playlists'
             >
              {playlists.map((item, index) => {
                return (
                  <div
                    className={`d-flex align-items-center`}
                    key={`allPlayLists_${item}_${index}`}
                  >
                    <input
                      ref={ref}
                      value={item._id}
                      type='checkbox'
                      className={`${classes.checkbox} form-check-input boxShedow_none`}
                      id={`checkBox_${index}`}
                      onChange={updateExsistingPlaylists(index)}
                      checked={selectIsChecked(item.cartoons, item._id)}
                      // checked={!!playlists?.find(playlist => playlist._id === item._id)?.cartoons.includes(cartoonId)}
                    />
                    <label
                      htmlFor={`checkBox_${index}`}
                      className={`cursor-pointer ${classes.playlist_name}`}
                    >
                      {item.title}
                    </label>
                  </div>
                );
              })}
              {playlists?.length < playlistCount ? (
                <Button 
                 divStyle={`w-100 d-flex justify-content-center`}
                 buttonStyle={`${classes.more} mb-0 mt-3 border-0 justify-content-center`}
                 text={`${ctx.data?.more[ctx.language]} ...`}
                 onClick={() => {setLimit(limit + defaultLimit); setUpdate(true)}}
                />
              ) : null}
            </div>
            <div className='d-flex justify-content-end'>
              {['cancel', 'save'].map((item, index) => {
                return (
                  <Button
                  disabled={item === "save" && disableSaveButton}
                  key={`button_${item}`}
                  onClick={() => playListAction(item)}
                    buttonStyle={`${classes[item]} ${
                      index === 0 ? 'bg-transparent' : ''
                    } border-0`}
                    text={ctx.data && ctx.data[item][ctx.language]}
                  />
                );
              })}
            </div>
          </>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default AddNewPlayList;
